import { PDFDownloadLink } from "@react-pdf/renderer";
import { classNames } from "../../../../helpers/classNames";

export default function PDFDownloadButton({
  document,
  fileName,
  label = "Download PDF",
  className = "",
  variant = "primary",
}) {
  const baseClasses = classNames(
    "relative flex border border-transparent justify-center items-center gap-2 text-white font-semibold text-base h-12 px-6 rounded-full",
    variant === "primary"
      ? "bg-primary-gradient"
      : variant === "secondary"
      ? "bg-transparent !text-deep-purple !border-gray-200 hover:!bg-primary/10"
      : "",
    "hover:opacity-90 transition-all duration-300",
    className
  );
  return (
    <PDFDownloadLink
      document={document}
      fileName={fileName}
      className={baseClasses}
    >
      {label}
    </PDFDownloadLink>
  );
}
